import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "panel"]
  static values = { floating: Boolean }

  connect() {
    this.onOutside = this.onOutside.bind(this)
    this.onKey = this.onKey.bind(this)
    this.onMove = this.close.bind(this)
  }

  disconnect() {
    this.unbind()
  }

  toggle() {
    this.panelTarget.hidden ? this.open() : this.close()
  }

  open() {
    this.panelTarget.hidden = false
    this.buttonTarget.setAttribute("aria-expanded", "true")

    if (this.floatingValue) this.float()

    document.addEventListener("click", this.onOutside)
    document.addEventListener("keydown", this.onKey)
  }

  float() {
    const button = this.buttonTarget.getBoundingClientRect()
    const panel = this.panelTarget
    const width = panel.offsetWidth
    const height = panel.offsetHeight
    const gap = 6
    const below = button.bottom + gap + height <= window.innerHeight

    panel.style.position = "fixed"
    panel.style.top = `${below ? button.bottom + gap : Math.max(gap, button.top - gap - height)}px`
    panel.style.left = `${Math.min(Math.max(gap, button.right - width), window.innerWidth - width - gap)}px`
    panel.style.right = "auto"
    panel.style.marginTop = "0"

    window.addEventListener("scroll", this.onMove, { capture: true, passive: true })
    window.addEventListener("resize", this.onMove)
  }

  close() {
    this.panelTarget.hidden = true
    this.buttonTarget.setAttribute("aria-expanded", "false")

    this.unbind()
  }

  onOutside(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  onKey(event) {
    if (event.key !== "Escape") return

    this.close()
    this.buttonTarget.focus()
  }

  unbind() {
    document.removeEventListener("click", this.onOutside)
    document.removeEventListener("keydown", this.onKey)
    window.removeEventListener("scroll", this.onMove, { capture: true })
    window.removeEventListener("resize", this.onMove)
  }
}
